import { commonParams, userParams } from './config'

import axios from 'axios'
import { Toast } from 'mint-ui'
import { loginWithSession } from '@/assets/js/lifeCycle'

const debug = process.env.NODE_ENV !== 'production'

let webUrl
let uploadUrl
if (debug) {
  webUrl = 'http://test.kayike.com/UserServer/index.php'
  uploadUrl = 'http://test.kayike.com/ShopServer/index.php?action=UploadImg&type='
} else {
  webUrl = 'https://app.cardeek.com/UserServer/index.php'
  uploadUrl = 'https://app.cardeek.com/ShopServer/index.php?action=UploadImg&type='
}

export const uploadImg = (value, action) => {
  const url = uploadUrl + action
  return axios({
    url,
    method: 'post',
    data: value,
    processData: false,
    contentType: false
  }).then((res) => {
    return Promise.resolve(res.data)
  })
}
/**
 * GET 请求
 * @param {string} action 请求的行为
 * @param {JSON} params 请求行为所有的参数
 */
export const getAcion = (action, params) => {
  return commonGetAction(action, commonParams(), params)
}
/**
 * GET 请求（用户相关）
 * @param {string} action 请求的行为
 * @param {JSON} params 请求行为所有的参数
 */
export const getUserAction = (action, params) => {
  const data = Object.assign({}, userParams(), params, {
    action: action
  })

  return axios.get(webUrl, {
    params: data
  }).then((res) => {
    console.log('Get response:', res)
    return dataPreHandle(res.data)
  })
}
/**
 * GET 请求
 * @param {string} action 请求的行为
 * @param {JSON} commonParams 请求通用参数
 * @param {JSON} params 请求行为所有的参数
 */
export const commonGetAction = (action, commonParams, params) => {
  const data = Object.assign({}, commonParams, params, {
    action: action
  })

  return axios.get(webUrl, {
    params: data
  }).then((res) => {
    console.log('Get response:', res)
    return dataPreHandle(res.data)
  })
}

function dataPreHandle (data) {
  if (data.s === 1005) {
    loginWithSession(() => {
      window.location.hash = '#/cardBag'
    }, () => {
      window.location.hash = '#/indexOne'
    })
  } else if (data.s !== 0) {
    Toast({
      message: ((data.m === '') ? '网络不给力' : data.m),
      position: 'middle',
      duration: 2500
    })
  }
  return Promise.resolve(data)
}



// WEBPACK FOOTER //
// ./src/assets/js/axios.js